import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../../assets/images/navbar/Solveesy.svg';
import { Button } from '../../atoms';
import hamberg from "../../../assets/images/navbar/hamburger.png"

const NavbarWithSubmenu = ({ context }:any) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { footerRef } = context || {};
   
  const handleGetStarted = () => {
    // Scroll to footer after a short delay to ensure navigation completes
    setTimeout(() => {
      if (footerRef && footerRef.current) {
        footerRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleGoToHowitWork = (path:string,section:string) => {
    navigate(`${path}`, { state: { scrollTo:`${section}` } });
  };
  
  // Determine active tab based on current path
  const getActiveTab = (path: string) => {
    if (path === '/') return 'Home';
    if (path.includes('/about')) return 'About';
    if (path.includes('/datadriven')) return 'About';
    if (path.includes('/howitwork')) return 'How It Works';
    if (path === '/contact') return 'Contact';
    if (path === '/blogs') return 'Blogs';
    if (path === '/legal') return 'Legal';
    return '';
  };
  
  const [activeTab, setActiveTab] = useState(getActiveTab(location.pathname));
  const [showAboutSubmenu, setShowAboutSubmenu] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleTabClick = (tabName: string, path: string) => {
    if (tabName === 'About') {
      setShowAboutSubmenu(!showAboutSubmenu);
    } else {
      setActiveTab(tabName);
      setShowAboutSubmenu(false);
      navigate(path);
      setMobileMenuOpen(false); // Close mobile menu after navigation
    }
  };

  // Close the submenu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.about-menu-container') && !target.closest('.mobile-menu-button')) {
        setShowAboutSubmenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setActiveTab(getActiveTab(location.pathname));
  }, [location.pathname]);

  // Handle body scroll when menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [mobileMenuOpen]);

  return (
    <nav className="flex  items-center justify-between bg-white px-4 md:px-15 py-4">
      <div className="flex items-center">
        <img 
          src={logo} 
          alt="Solveesy Logo" 
          className="cursor-pointer ml-2 md:ml-12 h-8 md:h-auto"
          onClick={() => {
            setActiveTab('Home');
            navigate('/');
          }} 
        />
      </div>

      {/* Mobile Menu Button */}
      <div className="md:hidden">
        <img src={hamberg} className="h-[30px]"   onClick={() => setMobileMenuOpen(!mobileMenuOpen)} />
       
      </div>

      {/* Desktop Navigation */}
      <div className="hidden md:flex items-center space-x-8 mr-20 bg-gradient-to-b from-transparent to-white">
        {/* Home Link */}
        <a
          href="#"
          className={`text-black text-base font-helvetica ${activeTab === 'Home' ? 'font-bold' : 'font-normal'}`}
          onClick={(e) => {
            e.preventDefault();
            handleTabClick('Home', '/');
          }}
        >
          Home
        </a>

        {/* How It Works Link */}
        <a
          href="#"
          className={`text-black text-base font-helvetica ${activeTab === 'How It Works' ? 'font-bold' : 'font-normal'}`}
          onClick={(e) => {
            e.preventDefault();
            handleTabClick('How It Works', '/howitwork');
          }}
        >
          How It Works
        </a>

        <a
          href="#"
          className={`text-black text-base font-helvetica ${activeTab === 'Legal' ? 'font-bold' : 'font-normal'}`}
          onClick={(e) => {
            e.preventDefault();
            handleTabClick('Legal', '/legal');
          }}
        >
          Legal
        </a>

        {/* About Tab with Submenu */}
        <div className="relative about-menu-container">
          <a
            href="#"
            className={`text-black text-base font-helvetica ${activeTab === 'About' || activeTab === 'About Us' || activeTab === 'Option 2' ? 'font-bold' : 'font-normal'}`}
            onClick={(e) => {
              e.preventDefault();
              handleTabClick('About', '/about');
            }}
          >
            About
          </a>
          
          {/* Submenu that appears directly under the About tab */}
          {showAboutSubmenu && (
            <div 
              className="absolute left-0 top-full mt-2 w-max bg-white shadow-lg rounded-md z-10 py-2 cursor-pointer"
            >
              <a 
                className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab('About Us');
                  setShowAboutSubmenu(false);
                  navigate('/about');
                }}
              >
                About Us
              </a>
              <div className="border-t px-2" />
              <a 
                className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab('About Us');
                  setShowAboutSubmenu(false);
                  navigate('/datadriven');
                }}
              >
                Data Driven Collections
              </a>
            </div>
          )}
        </div>

        {/* Contact Link */}
        <a
          href="#"
          className={`text-black text-base font-helvetica ${activeTab === 'Contact' ? 'font-bold' : 'font-normal'}`}
          onClick={(e) => {
            e.preventDefault();
            handleTabClick('Contact', '/contact');
          }}
        >
          Contact
        </a>
        <a
            href="#"
          className={`text-black text-base font-helvetica ${activeTab === 'Blogs' ? 'font-bold' : 'font-normal'}`}
          onClick={(e) => {
            e.preventDefault();
            handleTabClick('Blogs', '/blogs');
          }}
        >
          Blogs
        </a>

        {/* Get Started Button */}
        <Button
          className="w-[fit] text-[#FFFFFF] bg-[#015cfd] text-white text-[16px] font-normal"
          onClick={() =>  handleGoToHowitWork('/howitwork', 'getStart')}
        >
          Get Started
        </Button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden fixed inset-0 w-1/2 bg-[#fff] z-50 pt-20 px-6 overflow-y-auto overflow-hidden">
          {/* Close (X) SVG Button */}
<button
  onClick={() => setMobileMenuOpen(false)}
  className="absolute top-4 right-4 p-2 focus:outline-none"
  aria-label="Close Menu"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6 text-black"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
</button>

          <div className="flex flex-col space-y-6">
            {/* Home Link */}
            <a
              href="#"
              className={`text-black text-xl font-helvetica ${activeTab === 'Home' ? 'font-bold' : 'font-normal'}`}
              onClick={(e) => {
                e.preventDefault();
                handleTabClick('Home', '/');
              }}
            >
              Home
            </a>

            {/* How It Works Link */}
            <a
              href="#"
              className={`text-black text-xl font-helvetica ${activeTab === 'How It Works' ? 'font-bold' : 'font-normal'}`}
              onClick={(e) => {
                e.preventDefault();
                handleTabClick('How It Works', '/howitwork');
              }}
            >
              How It Works
            </a>

            {/* Legal Link */}
            <a
              href="#"
              className={`text-black text-xl font-helvetica ${activeTab === 'Legal' ? 'font-bold' : 'font-normal'}`}
              onClick={(e) => {
                e.preventDefault();
                handleTabClick('Legal', '/legal');
              }}
            >
              Legal
            </a>

            {/* About Link - On mobile, clicking "About" reveals the submenu options directly below */}
            <div className="about-menu-container">
              <a
                href="#"
                className={`text-black text-xl font-helvetica ${activeTab === 'About' ? 'font-bold' : 'font-normal'}`}
                onClick={(e) => {
                  e.preventDefault();
                  setShowAboutSubmenu(!showAboutSubmenu);
                }}
              >
                About
                <span className="ml-2">
                  {showAboutSubmenu ? '▲' : '▼'}
                </span>
              </a>
              
              {/* About submenu items */}
              {showAboutSubmenu && (
                <div className="pl-4 mt-4 space-y-4">
                  <a 
                    className="block text-lg text-gray-700"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab('About Us');
                      setMobileMenuOpen(false);
                      navigate('/about');
                    }}
                  >
                    About Us
                  </a>
                  <a 
                    className="block text-lg text-gray-700"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab('About Us');
                      setMobileMenuOpen(false);
                      navigate('/datadriven');
                    }}
                  >
                    Data Driven Collections
                  </a>
                </div>
              )}
            </div>

            {/* Contact Link */}
            <a
              href="#"
              className={`text-black text-xl font-helvetica ${activeTab === 'Contact' ? 'font-bold' : 'font-normal'}`}
              onClick={(e) => {
                e.preventDefault();
                handleTabClick('Contact', '/contact');
              }}
            >
              Contact
            </a>
               <a
            href="#"
          className={`text-black text-base font-helvetica ${activeTab === 'Blogs' ? 'font-bold' : 'font-normal'}`}
          onClick={(e) => {
            e.preventDefault();
            handleTabClick('Blogs', '/blogs');
          }}
        >
          Blogs
        </a>

            {/* Get Started Button */}
            <Button
              className="w-full py-3 text-[#FFFFFF] bg-[#015cfd] text-white text-[16px] font-normal rounded-md mt-4"
              onClick={() => {
                 handleGoToHowitWork('/howitwork', 'getStart')
                setMobileMenuOpen(false);
              }}
            >
              Get Started
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavbarWithSubmenu;